import { Context } from "@/providers/session.provider";
import { useContext } from "react";

const useSession = () => {
  const context = useContext(Context);

  if (context === null) {
    throw new Error(
      "Cannot use the 'useSession' hook outside the 'SessionProvider'.",
    );
  }

  return context;
};

export default useSession;
